import useAsyncData from 'src/utils/useAsyncData';
import { getAuthorizationStateAPI } from 'src/serverApi/authorization';

const useAuthorization = () => {
  const [
    fetchAuthorizationState,
    wasAuthorizationStateFetched,
    isAuthorizationStateLoading,
    authorizationState,
    authorizationStateError,
  ] = useAsyncData(getAuthorizationStateAPI);

  return {
    fetchAuthorizationState,
    wasAuthorizationStateFetched,
    isAuthorizationStateLoading,
    authorizationState,
    authorizationStateError,
  };
};

export default useAuthorization;
